module.exports = __webpack_public_path__ + "img/pos--icon.99d8dabd.svg";